import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlSegment } from '@angular/router';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { LogService } from '../log/log.service';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class VendorOverviewRedirectGuard implements CanActivate {

  constructor(private router: Router,
              private authStore: AuthenticationStore,
              private logService: LogService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  Observable<boolean> | Promise<boolean> | boolean {
    if (this.authStore.hasPermission('ViewOverview')) {
      if (this.isMultiVendor()) {
        return true;
      } else {
        return false;
      }
    } else {
      this.logService.debug('Redirecting to payment page since user has no permission to see the Overview page');

      let navigateCommands = route.parent.url.map((segment: UrlSegment) => segment.path);
      navigateCommands.push('commission');
      this.router.navigate(navigateCommands);

      return false;
    }
  }

  isMultiVendor() {
    return this.authStore.hasPermission('MultiVendor');
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/vendor-overview-redirect-guard.ts